import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

import PageSectionHeader from './SectionHeader';

import { getSetting } from '../../helpers/Settings';
import { isValidUrl } from '../../helpers/Validators';

const PageSectionFeaturedCollections = ({ section, isLoggedIn }) => {
  if (section.collections.length === 0) {
    return null;
  }

  const customStyle = {
    ...(getSetting('cs1') && { borderLeftColor: '#dc1f2b' }),
  };

  return (
    <div className="custom-page-section landing-featured-images">
      <Container>
        <PageSectionHeader section={section} />
      </Container>
      <Container fluid>
        <div className="landing-featured-images-wrapper">
          {section.collections.map(collection => {
            const LinkTag = (!isLoggedIn && isValidUrl(collection.custom_url)) ? 'a' : Link;

            return (
              <LinkTag
                key={collection.id}
                to={LinkTag === 'a' ? undefined : `/collections/${collection.uuid}`}
                href={LinkTag === 'a' ? collection.custom_url : undefined}
                className={`landing-featured-images-item item${Math.min(section.collections.length, 4)}`}
                style={{
                  backgroundImage: collection.featured_file ? `url('${collection.featured_file.urls.thumbnailx2}')` : '',
                }}
              >
                <div className="featured-image-header" style={customStyle}>
                  {collection.title && (
                    <h3>{collection.title}</h3>
                  )}
                  {collection.subtitle && (
                    <h4>{collection.subtitle}</h4>
                  )}
                </div>
              </LinkTag>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

PageSectionFeaturedCollections.propTypes = {
  section: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default PageSectionFeaturedCollections;
